import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }: { children: any }) => {
  const isAuthenticated = localStorage.getItem("Token");
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default PrivateRoute;
